<template>
  <div
    :class="$style.root"
  >
    <h1 :class="$style.heading">
      {{ title }}
    </h1>

    <CoreBlocksComponent
      v-if="localizedData.blocks"
      :blocks="localizedData.blocks"
      :withinModal="true"
    />

    <div
      :class="$style.list"
      v-if="localizedData?.entries?.length > 0"
    >
      <LayoutAccordionComponent
        :default-value="localizedData?.entries[0]?.id"
        :default-active-id="localizedData?.entries[0]?.id"
      >
        <template v-slot="slotProps">
          <PagesFranceSlugEntryComponent
            v-for="(entry, index) in localizedData?.entries"
            :key="entry.id"
            :entry="entry"
            :value="entry?.id"
            :active="slotProps?.activeId === entry?.id"
          />
        </template>
      </LayoutAccordionComponent>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  pageData: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

const title = computed(() => i18nGetLocalizedString(localizedData?.value?.titles))

</script>

<style module>
.root {
  position: relative;

  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 2);
}

.heading {
  composes: reset-heading font-size-large from global;
  composes: container--default from global;

  text-align: center;
  margin-bottom: calc(var(--width--button--round) - var(--unit--vertical));
}

.list {
  padding: 0 var(--unit--horizontal);
}
</style>
